/* i18n Init
 */
export const LANG_MAP = {
  // Lazy load, because "promise"
  en: () => import('../../assets/i18n/en.json'),
  ru: () => import('../../assets/i18n/ru.json'),
  de: () => import('../../assets/i18n/de.json'),
  it: () => import('../../assets/i18n/it.json'),
};

export const LANGS = Object.keys(LANG_MAP);

/*
 */
export const get_lang_bydomain = (): string => {
  const host = window.location.hostname;
  const subdomain = host.split('.')[0];
  return LANGS.includes(subdomain) ? subdomain : LANGS[0];
};

/*
 */
export const init_i18n = async () => {
  const lang = get_lang_bydomain();

  if (LANG_MAP[lang]) {
    const module = await LANG_MAP[lang]();
    (window as any)['__custom__locale__translations'] = module.default || module;
    console.debug(`[!] LANG=${lang}`, module);
    init_heplers();
  } else {
    console.error(`Unsupported lang "${lang}"`);
  }
};

/*
 */
const init_heplers = () => {
  window.addEventListener('message', (event: any) => {
    if (event.data?.type === 'get_translations') {
      event.source?.postMessage(
        {
          type: 'translations',
          payload: (window as any)['__custom__locale__translations'],
        },
        event.origin,
      );
    }
  });
};
